import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  createWorkingUnit,
  deleteWorkingUnit,
  getWorkingUnit,
  moveWorkingUnit,
  updateWorkingUnit,
} from "libs/api/working_unit";

// ServiceType Thunk
export const getWorkingUnitThunk = createAsyncThunk(
  "working_unit/get",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
    headers,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getWorkingUnit(pathname, queryParams, headers);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Create WorkingUnit Thunk
export const createWorkingUnitThunk = createAsyncThunk(
  "working_unit/create",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams = "",
    body,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createWorkingUnit(pathname, queryParams, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Update WorkingUnit Thunk
export const updateWorkingUnitThunk = createAsyncThunk(
  "working_unit/update",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateWorkingUnit(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Move WorkingUnit Thunk
export const moveWorkingUnitThunk = createAsyncThunk(
  "working_unit/move",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await moveWorkingUnit(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Delete WorkingUnit Thunk
export const deleteWorkingUnitThunk = createAsyncThunk(
  "working_unit/delete",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteWorkingUnit(pathname);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);
